var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('section', {
        class: _vm.$style.container
    }, [
        _setup.showNavBar ? _c('nav-bar-with-tracking', {
            class: _vm.$style.navBar,
            attrs: {
                "left-arrow": _setup.canBack,
                "title": _setup.title,
                "safe-area-inset-top": "",
                "fixed": "",
                "placeholder": "",
                "z-index": 10
            },
            on: {
                "click-left": _setup.goBack
            },
            scopedSlots: _vm._u([
                {
                    key: "right",
                    fn: function fn() {
                        return [
                            _c('router-view', {
                                attrs: {
                                    "name": "menu"
                                }
                            })
                        ];
                    },
                    proxy: true
                }
            ], null, false, 2090285051)
        }) : _vm._e(),
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('router-view')
        ], 1)
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
